import React from 'react';
import { propTypes } from 'redux-form';
import CheckboxSwitch from '../../../common/checkboxSwitch';
import Select from '../../../common/select';
import RangeSelect from '../../../common/rangeSelect';
import { USE_SERVICE_DURATION_FOR_TIMES } from '../../barbers/constants';
import { minuteOptionShape } from '../../../common/hoc/withMinuteOptions';
import Input from '../../../common/input';
import HoursMinsSelect from '../../../common/NotificationMethods/components/HoursMinsSelect';
import { t } from '../../../../modules/infra/i18n';

const NotAvailableSelect = props => (
  <select className="c-select c-select--small" disabled {...props}>
    <option>N/A</option>
  </select>
);

const maxHours = 24;
const customHours = [48, 72, 96];

const BarberSettingsRow = ({ fields, showBookNoPay, minInterval, minuteOptionsNoZero }) => (
  <div className="c-table-card">
    {fields.map((barber, index, field) =>
      <div className="c-table-card__row" key={index}>
        <div className="c-table-card__cell u-2/20">
          {field.get(index).name}
        </div>
        <div className="c-table-card__cell u-1/20" display-if={showBookNoPay}>
          <CheckboxSwitch
            name={`${barber}.bookNoPay`}
          />
        </div>
        <div className="c-table-card__cell u-1/20">
          <CheckboxSwitch
            name={`${barber}.tipEnabled`}
          />
        </div>
        <div className="c-table-card__cell u-1/20">
          <CheckboxSwitch
            name={`${barber}.lateTipping`}
          />
        </div>
        <div className="c-table-card__cell u-1/20">
          <CheckboxSwitch
            name={`${barber}.allowMultipleServices`}
          />
        </div>
        <div className="c-table-card__cell u-2/20">
          <Select
            name={`${barber}.minServiceLen`}
            className="c-select c-select--small"
            suffix=" mins"
            options={[...minuteOptionsNoZero, {
              value: USE_SERVICE_DURATION_FOR_TIMES,
              label: t('settings:barber_settings.by_service_length'),
            }]}
            valueField="value"
            textField="label"
            empty
          />
        </div>
        <div className="c-table-card__cell u-2/20">
          <Select
            name={`${barber}.bookingInterval`}
            className="c-select c-select--small c-select-140"
            suffix=" mins"
            options={minuteOptionsNoZero}
            valueField="value"
            textField="label"
            empty
          />
        </div>
        <div className="c-table-card__cell u-1/20">
          <Input
            className="c-input c-input--small u-width-60"
            type="number"
            placeholder="Number of days"
            name={`${barber}.advanceBookDays`}
            min="1"
            max="365"
            step="1"
            required
          />
        </div>
        <div className="c-table-card__cell u-2/20">
          <div className="layout__item u-1/2 u-mb0 u-pl0">
            <RangeSelect
              name={`${barber}.advanceBookMins.hours`}
              className="c-select c-select--small"
              valueSuffix=" h"
              start={0}
              end={25}
            />
          </div>
          <div className="layout__item u-1/2 u-mb0 u-pl0">
            <RangeSelect
              name={`${barber}.advanceBookMins.minutes`}
              className="c-select c-select--small"
              valueSuffix=" m"
              start={0}
              end={60}
              increment={minInterval}
            />
          </div>
        </div>
        <div className="c-table-card__cell u-1/20">
          <CheckboxSwitch
            name={`${barber}.canCustomerCancel`}
          />
        </div>
        <div className="c-table-card__cell u-2/20">
          <div className="layout__item u-1/2 u-mb0 u-pl0">
            <NotAvailableSelect display-if={!field.get(index).canCustomerCancel} />
            <RangeSelect
              display-if={field.get(index).canCustomerCancel}
              name={`${barber}.advanceCancelMins.hours`}
              valueSuffix=" h"
              className="c-select c-select--small"
              start={0}
              end={25}
            />
          </div>
          <div className="layout__item u-1/2 u-mb0 u-pl0">
            <NotAvailableSelect display-if={!field.get(index).canCustomerCancel} />
            <RangeSelect
              name={`${barber}.advanceCancelMins.minutes`}
              display-if={field.get(index).canCustomerCancel}
              className="c-select c-select--small"
              valueSuffix=" m"
              start={0}
              end={60}
              increment={minInterval}
            />
          </div>
        </div>
        <div className="c-table-card__cell u-2/20">
          <HoursMinsSelect
            name={`${barber}.customerReminder.barber_reminder.time`}
            max={{ hours: maxHours, minutes: 5 }}
            customHours={customHours}
          />
        </div>
        <div className="c-table-card__cell u-2/20">
          <HoursMinsSelect
            name={`${barber}.customerReminder.reminder.time`}
            max={{
              hours: Math.min(field.get(index).customerReminder.barber_reminder.time.hours, maxHours),
              minutes: 5,
            }}
            customHours={
              customHours.filter(hour => hour < field.get(index).customerReminder.barber_reminder.time.hours)
            }
          />
        </div>
      </div>)
    }
  </div>

  );

BarberSettingsRow.propTypes = {
  fields: propTypes.array.isRequired,
  showBookNoPay: propTypes.bool,
  minInterval: propTypes.number,
  minuteOptionsNoZero: minuteOptionShape,
};
BarberSettingsRow.defaultProps = {
  showBookNoPay: false,
};

export default BarberSettingsRow;
